import React from 'react';
import {Heading} from '@albert-io/atomic';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import type {
  AssignmentModelV3,
  QuestionModelV3,
  StandardModelV1,
  StudentModelV2
} from '@albert-io/models';

interface HeadingProps {
  className?: string;
}

function AssignmentHeading({
  className,
  data
}: HeadingProps & {
  data: AssignmentModelV3;
}) {
  const text = data?.getName?.();
  return (
    <Heading size='xl' className={className}>
      {text}
    </Heading>
  );
}

function QuestionHeading({className, data}: HeadingProps & {data: QuestionModelV3}) {
  const text = data?.getTitle?.();
  return (
    <Heading size='xl' className={className}>
      <MarkdownRendererV2 text={text} />
    </Heading>
  );
}

function StandardHeading({
  className,
  data
}: HeadingProps & {
  data: StandardModelV1;
}) {
  const text = data?.getTitle?.();
  return (
    <Heading size='xl' className={className}>
      {text}
    </Heading>
  );
}

function StudentHeading({
  className,
  data
}: HeadingProps & {
  data: StudentModelV2;
}) {
  const firstName = data?.getFirstName?.();
  const lastName = data?.getLastName?.();
  return (
    <Heading size='xl' className={className}>
      {firstName && lastName && `${firstName} ${lastName}`}
    </Heading>
  );
}

export default {
  assignments: AssignmentHeading,
  questions: QuestionHeading,
  standards: StandardHeading,
  students: StudentHeading,
  classrooms: () => null,
  teachers: () => null,
  schools: () => null
};
